<template>
  <el-main>
    <banner></banner>
    <block-title title="客户案例"></block-title>
    <customer-example></customer-example>
    <block-title title="战略合作"></block-title>
    <cooperation></cooperation>
    <get-more></get-more>
  </el-main>
</template>

<script>
import Banner from '../../components/Banner'
import BlockTitle from '../../components/BlockTtitle'
import GetMore from '../../components/GetMore'
import CustomerExample from './components/CustomerExample'
import Cooperation from './components/Cooperation'

export default {
  name: 'Example',
  components: {Cooperation, CustomerExample, GetMore, Banner, BlockTitle}
}
</script>

<style scoped lang="stylus">
  .el-main
    padding: 20px 0
</style>



// WEBPACK FOOTER //
// src/pages/example/Example.vue